import React from 'react';
import PropTypes from 'prop-types';
import _split from 'lodash/split';

import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import TextField from '@material-ui/core/TextField';
import Switch from '@material-ui/core/Switch';
import Divider from '@material-ui/core/Divider';

class Support extends React.PureComponent {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    value: PropTypes.shape({
      emails: PropTypes.array,
      enabled: PropTypes.bool,
    }),
    errorMessage: PropTypes.string,
  };

  constructor(props) {
    super(props);
    const { emails } = props.value;

    this.state = {
      emails: emails ? emails.join('\n') : '',
      emailsValueAsArray: emails || [],
    };
  }

  componentDidUpdate(prevProps, prevState) {
    const { value } = this.props;

    if (this.state.emailsValueAsArray !== value.emails) {
      this.setState({
        emails: value.emails ? value.emails.join('\n') : '',
      });
    }
  }

  handleTextChange = e => {
    const { onChange } = this.props;
    const emails = e.target.value;
    const emailsValueAsArray = this.convertEmailStringToArray(emails);

    this.setState({ emails, emailsValueAsArray });

    onChange('client.settings.support.emails', emailsValueAsArray);
  };

  handleChangeSupportEnabled = e => {
    const { onChange } = this.props;
    onChange('client.settings.support.enabled', e.target.checked);
  };

  convertEmailStringToArray = emailString => {
    let value = emailString;
    let supportEmails = [];
    if (value.length) {
      // This code snippet turns a string into an array.
      // Each indent represents spliting strings to a bigger array.
      // Starts splitting with `\n`, `,` and lastly ` `.
      const supportEmailsSplit = _split(value, '\n');
      supportEmailsSplit.forEach(email => {
        const emailCommaSplit = _split(email, ',');
        emailCommaSplit.forEach(splitCommaEmail => {
          const emailSpaceSplit = _split(splitCommaEmail, ' ');
          emailSpaceSplit.forEach(splitSpaceEmail => {
            if (splitSpaceEmail.length) {
              supportEmails.push(splitSpaceEmail);
            }
          });
        });
      });

      // Removes any lingering spaces, linebreaks or commas on a string
      supportEmails.map(email => {
        email.split(' ').join('');
        email.split(',').join('');
        email.split('\n').join('');
        return email;
      });
    }

    return supportEmails;
  };

  render() {
    const { value, errorMessage } = this.props;

    return (
      <Card>
        <CardHeader
          title="Support"
          action={
            <Switch
              checked={value.enabled}
              inputProps={{ 'aria-label': 'support switch' }}
              onChange={this.handleChangeSupportEnabled}
            />
          }
          subheader="Allow your users to send feedback to a support team on your end to resolve data
          inconsistencies quicker and easier."
        />
        <Divider />
        <CardContent>
          <TextField
            id="support recipients input"
            onChange={this.handleTextChange}
            value={this.state.emails}
            label="Add Support Recipients"
            multiline
            fullWidth
            disabled={!value.enabled}
            error={!!errorMessage}
            helperText={
              errorMessage ||
              'Add support recipients here. You may separate emails by spaces, commas, line breaks, or any combination of these.'
            }
            style={{ maxWidth: 450 }}
          />
        </CardContent>
      </Card>
    );
  }
}

export default Support;
